import interceptedAxios from '../../../utils/interceptedAxios'

export async function deviceDeleteCampaign (
  deviceId: string,
  onSuccess: (deleteStatusData: string, httpStatus: number) => any,
  onFailure: (errorMessage: string, httpStatus: number) => any
): Promise<void> {
  const url = `/asset-config-service/api/v1/udp/tiq/commands/configuration/device-template/${deviceId}`
  interceptedAxios
    .delete(url, { timeout: 40000 }) // timeout after 3 minutes = 3 × 60 x 1000
    .then((response) => {
      const parseResponse = response.data
      if (parseResponse.error === false) {
        if (parseResponse.data !== null && parseResponse.data !== undefined) {
          onSuccess(parseResponse.data, parseResponse.http_status)
        } else {
          onFailure(parseResponse.error, parseResponse.http_status)
        }
      } else {
        onFailure(parseResponse.error_message, parseResponse.http_status)
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        onFailure(error.response.data?.error_message ?? 'Network Error', error.response.http_status)
      } else {
        onFailure('Network Error', 404)
      }
    })
}
